<template>
  <a
    href="#"
    class="pr-2"
    @click.prevent.stop="$emit('click-collapse-link', id)"
  >
    <small>{{ title }}
      <fa-icon
        v-if="!showDetail"
        icon="chevron-right"
      />
      <fa-icon
        v-if="showDetail"
        icon="chevron-down"
      />
    </small>
  </a>
</template>
<script>

export default {
    name: 'CollapseLink',
    props: {
        id: {
            type: String,
            required: true,
        },
        showDetail: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
    },
    data() {
        return {};
    },
    mounted() {},
};
</script>
